import { Box, IconButton, Tooltip, Typography } from "@mui/material"
import { useStyles } from "./styles"
import { BreadCrumb, CustomTable } from "../../../../../../components"
import { useColumn } from "../../utils"
import { useTranslation } from "react-i18next"
import { icons } from "../../../../../../utils/icons"
import { FloatFilter } from "../../../../../../components/filtersDrawer/floatFliter"
import { useGeneralConfigContext } from "../../context"
import { useEffect, useLayoutEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { PathsEnum } from "../../../../../../utils/crud/paths"
import { BaseMenuClick } from "../../../../../../components/baseMenu"
import { MenuType } from "../../utils/enum"
import { emitEvent } from "../../../../../../hooks/emitter"
import { Events } from "../../../../../../hooks/emitter/types"
import { returnQuery } from "../../../../../../utils/methods/returnQuery"
import { RowConfig } from "../../utils/types"
import { configServices } from "../../../../../../utils/constants/callService"
import { Types } from "../../../../../../utils/enums"
import { handleAllErrors } from "../../../../../../utils/methods/handleErrors"

export default function Main() {
    const { filter, input, service, formData, loadings, setLoadings, setItem } = useGeneralConfigContext()
    const [row, setRow] = useState<RowConfig[]>([])
    const [totalPage, setTotalPage] = useState(1)
    const navigate = useNavigate()
    const handleMenu: BaseMenuClick = (item, data) => {
        switch (item.value as MenuType) {
            case MenuType.EDIT: {
                goForm({ id: data?.id })
                break
            }
            case MenuType.DELETE: {
                emitEvent(Events.modal, {
                    open: true,
                    title: t('general.service.areaDepartment.main.action.title') ?? '',
                    description: '',
                    cancel: (payload) => {
                        payload?.close()
                    },
                    confirm: (payload) => {
                        deleteConfig({ id: data?.id, close: payload?.close })
                    },
                })
                break
            }
        }
    }
    const column = useColumn({ click: handleMenu })
    const { t } = useTranslation()
    const styles = useStyles()

    const goForm = ({ id = '' }: { id?: string }) => {
        const path = `/${PathsEnum.OrganizationChart.AreaDepartment}/form`
        navigate(`${path}/${id}`)
    }

    const getConfigList = async () => {
        const query = returnQuery({ ...filter.query, filter: filter.query.filter?.replaceAll('+', '%2B') })
        setLoadings(prev => ({ ...prev, table: true }))
        const { data, format } = await configServices.config({ query })
        setLoadings(prev => ({ ...prev, table: false }))
        if (!!data.errors || !format?.length || !data.totalPages) {
            setRow([])
            return
        }
        setTotalPage(data.totalPages)
        setRow(format)
    }
    const deleteConfig = async ({ id, close }: { id?: string; close?: () => void }) => {
        if (!id || !close) { return }
        emitEvent(Events.modal_extra, { loading: true })
        const response = await configServices.deleteConfig({ id })
        emitEvent(Events.modal_extra, { loading: false })
        if (response.errors) {
            const code = response?.errors?.[0]?.code
            emitEvent(Events.snackbar, { open: true, type: Types.ERROR, message: handleAllErrors(code, t, 'general.service.areaDepartment.main.snackbar.delete.error') })
            return
        }
        emitEvent(Events.snackbar, { open: true, type: Types.SUCCESS, message: t('general.service.areaDepartment.main.snackbar.delete.success') })
        close()
        getConfigList()
    }
    useLayoutEffect(() => {
        setItem({})
        formData.cleanFilter()
        service.getAreasService()
        service.getDepartmentService()
        service.getCatalogList()
    }, [])

    useEffect(() => {
        getConfigList()
    }, [filter.query.all])
    return (
        <Box className="main-container" sx={styles.container}>
            <BreadCrumb
                removeBreadcrumb={['organization-chart']}
                replaceLabels={{
                    form: '',
                    formEdit: '',
                    'organization-area-department': 'area-department-config'
                }}
            />

            <Box sx={styles.header}>
                <Typography variant="title_grey_big">{t('general.service.areaDepartment.main.title')}</Typography>

                <Box>
                    <Tooltip title={t('ToolTips.clearFilters')}>
                        <IconButton
                            sx={(styles.clean, (filter.counter || 0) > 0 ? null : styles.hide)}
                            onClick={() => {
                                filter.cleanFilter()
                            }}
                        >
                            {icons('clean')}
                        </IconButton>
                    </Tooltip>

                    <Tooltip title={t('ToolTips.create')}>
                        <IconButton onClick={() => { goForm({}) }} className='icon-size blue' sx={styles.icon}>{icons('add')}</IconButton>
                    </Tooltip>
                </Box>
            </Box>

            <CustomTable
                column={column}
                row={row}
                selected={-1}
                loader={loadings.table}
                order={
                    filter?.query.sort && {
                        count: filter.query?.sort?.count,
                        key: filter.query?.sort?.field,
                        order: filter.query?.sort?.sort,
                    }
                }
                sortable={(field, sort, count) => {
                    filter?.sortTable(field && sort ? { field: field, sort: sort, count } : undefined)
                }}
                handleChange={(page: number, pageSize: number) => {
                    filter?.handlePagination({ page, pageSize })
                }}
                serverSidePagination={{ page: filter?.paginationModel?.page + 1, size: filter?.paginationModel?.pageSize, totalPages: totalPage }}
            />

            <FloatFilter
                cleanFilter={filter.cleanFilter}
                counter={filter.counter}
                onChange={filter.onChange}
                values={filter.filterData}
                input={input}
                filter
                top={50}
            />
        </Box>
    )
}